
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bantuan/performa",
      function () {
        return require("private-next-pages/bantuan/performa.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bantuan/performa"])
      });
    }
  